// extracted by mini-css-extract-plugin
module.exports = {"rootS":"wc-tag_rootS__3hrEs","rootButton":"wc-tag_rootButton__MCCTD","rootProductTag":"wc-tag_rootProductTag__ts1Ry"};